module.exports = __webpack_public_path__ + "media/images/result_sets/icons/secure_icon-09bf2731c0ec9ca69d53df482e1f9625.svg";